import React from 'react';
import { motion } from 'framer-motion';
import { Brain, Sparkle, X } from '@phosphor-icons/react';
import { Button } from './ui/button';

/**
 * The small "Would you like to activate AI Analyst?" prompt card shown on the
 * Dashboard before the user has activated. Dismissible.
 */
const AIAnalystPromptCard = ({ onActivate, onDismiss }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -12 }}
      animate={{ opacity: 1, y: 0 }}
      className="relative overflow-hidden rounded-2xl border border-cyan-400/30 bg-gradient-to-br from-cyan-950/40 via-blue-950/30 to-zinc-950 p-5 sm:p-6 mb-6"
      data-testid="ai-analyst-prompt-card"
    >
      {/* Glow background */}
      <div className="pointer-events-none absolute -top-20 -right-16 w-64 h-64 rounded-full bg-cyan-400/15 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-24 -left-10 w-72 h-72 rounded-full bg-blue-500/10 blur-3xl" />

      <div className="relative flex items-start gap-4">
        <div className="hidden sm:flex flex-shrink-0 w-14 h-14 rounded-2xl bg-gradient-to-br from-cyan-400 to-blue-600 items-center justify-center shadow-lg shadow-cyan-500/30">
          <Brain size={28} weight="fill" className="text-white" />
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <Sparkle size={14} weight="fill" className="text-cyan-300" />
            <span className="text-[10px] font-bold uppercase tracking-wider text-cyan-300">New · Free for everyone</span>
          </div>
          <h3 className="text-lg sm:text-xl font-unbounded font-bold text-white leading-tight mb-1">
            Would you like to activate AI Analyst?
          </h3>
          <p className="text-sm text-zinc-300 leading-relaxed mb-4">
            Tell us your sector interests and our AI will analyze your portfolio, figure out your risk style, and suggest stocks tailored to you — in seconds.
          </p>

          <div className="flex flex-wrap items-center gap-2">
            <Button
              onClick={onActivate}
              className="bg-gradient-to-r from-cyan-400 to-blue-500 text-black font-bold rounded-full px-5 hover:scale-[1.02] transition-transform"
              data-testid="ai-analyst-activate-button"
            >
              <Brain size={16} weight="fill" className="mr-1.5" /> Activate AI Analyst
            </Button>
            <button
              onClick={onDismiss}
              className="text-sm text-zinc-400 hover:text-white px-4 py-2 rounded-full transition-colors"
              data-testid="ai-analyst-dismiss-button"
            >
              Not now
            </button>
          </div>
        </div>

        <button
          onClick={onDismiss}
          className="sm:hidden absolute top-2 right-2 text-zinc-500 hover:text-white"
          aria-label="Dismiss"
        >
          <X size={18} />
        </button>
      </div>
    </motion.div>
  );
};

export default AIAnalystPromptCard;
